'use client';

export { AspectRatio } from '@radix-ui/react-aspect-ratio';
